import { useTranslation } from "react-i18next";

const PageNotFound = () => {
    const { t } = useTranslation();

    return (
        <>
            {<div style={{ textAlign: 'center', marginTop: '50px' }}>
                <h1>404</h1>
                <p>{t('PAGE_NOT_FOUND')}</p>
                <a href="/">{t('MAIN')}</a>
            </div>}
        </>
    );
}

export default PageNotFound;